import { NumericUtils } from '@shared/utils/NumericUtils';
import { getSlTpNumericParameters } from './SLTPNumericUtils';
import { SlTpUtils } from '@shared/utils/Trading/SlTpUtils';
import { useEffect, useRef } from 'react';
import { ticksUtils } from '@shared/utils/Trading/TicksUtils';
export const useSLTPNumeric = ({ value, variableTickList, operationType, isSL, offsetType }) => {
    const lastValidPriceRef = useRef(isValidNumber(value) ? value : 0);
    useEffect(() => {
        if (isValidNumber(value)) {
            lastValidPriceRef.current = value;
        }
    }, [value]);
    const numericParams = getSlTpNumericParameters(isValidNumber(value) ? value : lastValidPriceRef.current, variableTickList, operationType, isSL, offsetType);
    const inOffsetMode = !isNullOrUndefined(offsetType);
    const onIncrement = (price) => {
        if (!isValidNumber(price)) {
            return lastValidPriceRef.current;
        }
        if (inOffsetMode) {
            return NumericUtils.valueUpDownChangeProcess(true, price, numericParams.step, numericParams.min, numericParams.max);
        }
        else {
            return ticksUtils.CalculatePrice(price, 1, variableTickList, true, offsetType);
        }
    };
    const onDecrement = (price) => {
        if (!isValidNumber(price)) {
            return lastValidPriceRef.current;
        }
        if (inOffsetMode) {
            return NumericUtils.valueUpDownChangeProcess(false, price, numericParams.step, numericParams.min, numericParams.max);
        }
        else {
            return ticksUtils.CalculatePrice(price, -1, variableTickList, true, offsetType);
        }
    };
    return {
        step: numericParams.step,
        min: numericParams.min,
        max: numericParams.max,
        precision: numericParams.precision,
        prefix: SlTpUtils.getSymbolForOffsetMode(offsetType),
        onIncrement,
        onDecrement
    };
};
